export default __webpack_public_path__ + "static/media/GunungTiluNatural.988dccd0.png";